import React, { useState, useRef, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap'
import { Link } from 'react-router-dom'
import { isEmpty } from 'lodash'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import ProductCard from '../../../components/Common/ProductCard'
import { getImagesOfProduct } from '../../../helpers/utils'
import { GeneralContext } from '../../../context/'
import ApiService from '../../../data/services/ApiService'

const StorePage = (props) => {
  const generalContext = useContext(GeneralContext)
  const { loading, setLoading } = generalContext

  const [storeName, setStoreName] = useState('')
  const [storeUrl, setStoreUrl] = useState('')
  const [profit, setProfit] = useState('')
  const [configModal, setConfigModal] = useState(false)
  const [urlAvailable, setUrlAvailable] = useState(true)

  const inputUrlRef = useRef(null)

  const toggleConfigModal = () => setConfigModal(!configModal)

  const toggleConfigStoreModal = () => {
    toggleConfigModal()
    setStoreName(props.store.name)
    setStoreUrl(props.store.url)
    setProfit(props.store.profit)
  }

  const checkAvailability = async (url) => {
    try {
      setLoading(true)
      const response = await ApiService.checkStoreUrl(url)
      if (response.data.success) {
        setUrlAvailable(response.data.available)
        if (!response.data.available) {
          toastr.error(`URL no disponible, por favor escribe otra.`, 'Error')
          inputUrlRef.current.focus()
        }
      }
    } catch(e) {
      toastr.error(`${e.response.data.message}`, 'Error')
    } finally {
      setLoading(false)
    }
  }

  const updateConfigStore = (e) => {
    toggleConfigModal()
    props.updateConfigStore(e, storeName, storeUrl, profit)
  }

  return (
    <React.Fragment>
      { props.loading && null }
      {
        !props.loading && isEmpty(props.store) && (
          <React.Fragment>
            <Card>
              <CardBody>
                Aún no tienes una tienda configurada, ¿Deseas comenzar a vender hoy mismo?
                <br /><br />
                <Link to={`/mi-tienda/crear`} className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2">
                  <i className="mdi mdi-plus mr-1"></i> Crear tienda
                </Link>
              </CardBody>
            </Card>
          </React.Fragment>
        )
      }
      {
        !isEmpty(props.store) && (
          <React.Fragment>
            <div style={{textAlign: 'right'}}>
              <Button
                color="primary"
                onClick={toggleConfigStoreModal}
                className="btn btn-primary waves-effect waves-light mb-2 mr-2"
              >
                Configuración
              </Button>
              <Button
                color="primary"
                onClick={() => props.history.push(`/mi-tienda/${props.store.id}/productos/modificar`)}
                className="btn btn-primary waves-effect waves-light mb-2 mr-2"
              >
                <i className={`mdi mdi-plus`}></i> Modificar productos
              </Button>
            </div>
            <Card>
              <CardBody>
                <CardTitle className="flex-fill">Mis Productos</CardTitle>
                <Row>
                  {!isEmpty(props.store.detail) && props.store.detail.map(
                    (item, key) => (
                      <Col key={key} sm={3} style={{ textAlign: 'center', marginBottom: '15px' }}>
                        <ProductCard
                          photos={getImagesOfProduct(item.product.gallery)}
                          code={`${item.product.supplierCode ? `Código ${item.product.supplierCode}` : ''}`}
                          price={`${item.product.wholeSalePrice || 0}`}
                          productName={item.product.name}
                          supplierName={item.product.supplier.nombreComercial}
                          showVariants={false}
                        />
                      </Col>
                    )
                  )}
                </Row>
              </CardBody>
            </Card>
          </React.Fragment>
        )
      }
      <div>
        <Modal isOpen={configModal} toggle={toggleConfigModal}>
          <ModalHeader toggle={toggleConfigModal}>Configuración de Mi tienda</ModalHeader>
          <ModalBody>
            <Form onSubmit={(e) => updateConfigStore(e)}>
              <Card>
                <CardBody>
                  <Row>
                    <Col sm="12">
                      <FormGroup>
                        <Label>
                          Nombre de tu tienda
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          required
                          maxLength="50"
                          value={storeName}
                          onChange={event => setStoreName(event.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <FormGroup>
                        <Label>
                          URL
                        </Label>
                        <InputGroup>
                          <Input
                            type="text"
                            className="form-control"
                            required
                            maxLength="50"
                            value={storeUrl}
                            innerRef={inputUrlRef}
                            onChange={event => {
                              const urlNoSpaces = event.target.value.replace(/ /g, '-')
                              const url = urlNoSpaces.replace(/[^a-zA-Z-]/g, '')
                              setStoreUrl(url)
                            }}
                            onBlur={event => checkAvailability((event.target.value))}
                          />
                          <InputGroupAddon addonType="append">
                            <InputGroupText>.{props.domain}</InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <FormGroup>
                        <Label>
                          Porcentaje de ganancia
                        </Label>
                        <Col sm="12" style={{ display: 'inline-flex' }}>
                          <FormGroup check>
                            <Label check style={{ cursor: 'pointer' }}>
                              <Input
                                type="radio"
                                name="profit"
                                value={20}
                                checked={profit === '20'}
                                style={{ cursor: 'pointer' }}
                                onChange={(event) => setProfit(event.target.value) }
                              />{' '}
                              20%
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label check style={{ cursor: 'pointer', marginLeft: '10px' }}>
                              <Input
                                type="radio"
                                name="profit"
                                value={30}
                                checked={profit === '30'}
                                style={{ cursor: 'pointer' }}
                                onChange={(event) => setProfit(event.target.value) }
                              />{' '}
                              30%
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label check style={{ cursor: 'pointer', marginLeft: '10px' }}>
                              <Input
                                type="radio"
                                name="profit"
                                value={50}
                                checked={profit === '50'}
                                style={{ cursor: 'pointer' }}
                                onChange={(event) => setProfit(event.target.value) }
                              />
                              50%
                            </Label>
                          </FormGroup>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="text-right">
                    <Col sm="12">
                      <Button
                        type="submit"
                        style={{ width: '100%' }}
                        color="primary"
                        className="btn btn-success waves-effect waves-light mb-2 mr-2"
                        disabled={loading || isEmpty(storeName) || isEmpty(storeUrl) || isEmpty(profit) || !urlAvailable}
                      >
                        Guardar cambios
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Form>
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default withRouter(StorePage)
